import React from 'react';

import { Flex, Icon, Text } from '~/components/blocks';
import { MedicationFollowupMessageOnAllPatientListFragment } from '~/graphql/generated/graphql';
import { Label } from '~/utils/label';

export const MessageSendAtColumn = ({
  latestFollowupMessage,
}: {
  latestFollowupMessage: MedicationFollowupMessageOnAllPatientListFragment | null;
}) => {
  if (!latestFollowupMessage) {
    return <>-</>;
  }
  const deliverResult = latestFollowupMessage.messageDeliverResult;
  const isError = deliverResult?.status === 'failed';
  const isScheduled = latestFollowupMessage.status === 'scheduled';

  const createdAt = `${Label.YYYYMMDDja(latestFollowupMessage.createdAt)} ${Label.HHMM(
    latestFollowupMessage.createdAt,
  )}`;

  return (
    <>
      {createdAt}
      {isScheduled && (
        <Flex flexDirection="row" alignItems="center">
          <Icon icon="info" size="m" color="blue" />
          <Text size="s" color="blue" fontWeight="bold">
            送信予定
          </Text>
        </Flex>
      )}
      {isError && (
        <Flex flexDirection="row" alignItems="center">
          <Icon icon="attention" size="m" />
          <Text size="s" color="pink" fontWeight="bold">
            送信エラー
          </Text>
        </Flex>
      )}
    </>
  );
};
